/**
 * Lecture défensive des variables d'environnement.
 *
 * Une variable Vite est toujours une chaîne (ou absente) : ces fonctions la
 * ramènent vers un type utilisable en retombant sur la valeur par défaut dès
 * que l'entrée est absente, vide ou invalide. Une configuration mal saisie ne
 * doit jamais empêcher le jeu de démarrer.
 */

/** Backend de rendu souhaité. `auto` = WebGPU si disponible, sinon WebGL2. */
export type RendererPreference = "auto" | "webgpu" | "webgl";

export const RENDERER_PREFERENCES: readonly RendererPreference[] = ["auto", "webgpu", "webgl"];

/** Accepte `true` / `1` comme vrai, `false` / `0` comme faux. */
export function parseBoolean(raw: string | undefined, fallback: boolean): boolean {
  if (raw === undefined || raw === "") return fallback;
  if (raw === "true" || raw === "1") return true;
  if (raw === "false" || raw === "0") return false;
  return fallback;
}

export function parseNumber(raw: string | undefined, fallback: number): number {
  if (raw === undefined || raw === "") return fallback;
  const parsed = Number.parseFloat(raw);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function parseRenderer(
  raw: string | undefined,
  fallback: RendererPreference,
): RendererPreference {
  return RENDERER_PREFERENCES.find((candidate) => candidate === raw) ?? fallback;
}
